import { OrderType } from "../../../../interfaces/delivery-company/orders";
import { IPickupTask } from "../../../../interfaces/delivery-company/tasks";
import { AlertsData } from "./alerts";

export const formatDaysLate = (date: string) => {
    const currentDate = new Date();
    const targetDate = new Date(date);
    const diffTime = currentDate.getTime() - targetDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    console.log("diff days = ", diffDays)
    return diffDays > 0 ? `${diffDays} days late` : 'On time';
};

export interface OrdersAlerts { UNDELIVERED: OrderType[]; UNPAID: OrderType[] }
export const categorizeOrderAlerts = (alertsData?: AlertsData): { active_orders: OrdersAlerts, snoozed_orders: OrdersAlerts } => {
    const snoozedAlerts = alertsData
        ? {
            UNDELIVERED: alertsData.UNDELIVERED.filter(
                (order) =>
                    order.snoozed_until &&
                    new Date(order.snoozed_until).getTime() > Date.now()
            ),
            UNPAID: alertsData.UNPAID.filter(
                (order) =>
                    order.snoozed_until &&
                    new Date(order.snoozed_until).getTime() > Date.now()
            ),
        }
        : { UNDELIVERED: [], UNPAID: [] };

    const activeAlerts = alertsData
        ? {
            UNDELIVERED: alertsData.UNDELIVERED.filter(
                (order) =>
                    !order.snoozed_until ||
                    new Date(order.snoozed_until).getTime() <= Date.now()
            ),
            UNPAID: alertsData.UNPAID.filter(
                (order) =>
                    !order.snoozed_until ||
                    new Date(order.snoozed_until).getTime() <= Date.now()
            ),
        }
        : { UNDELIVERED: [], UNPAID: [] };

    return { active_orders: activeAlerts, snoozed_orders: snoozedAlerts }
}

export const categorizePickupAlerts = (alertsData?: AlertsData): { recent_pickups: IPickupTask[], late_pickups: IPickupTask[] } => {
    const recentPickups = alertsData ? alertsData.INCOMPLETE_PICKUPS.filter(task => {
        if (!task.creation_date) return true
        const creationTime = new Date(task.creation_date).getTime();
        const now = Date.now();
        return task.creation_date && creationTime > now - 24 * 60 * 60 * 1000;
    })
        : []

    const latePickups = alertsData ? alertsData.INCOMPLETE_PICKUPS.filter(task => {
        if (!task.creation_date) return true
        const creationTime = new Date(task.creation_date).getTime();
        const now = Date.now();
        return task.creation_date && creationTime <= now - 24 * 60 * 60 * 1000;
    })
        : []

    return { recent_pickups: recentPickups, late_pickups: latePickups }
}